

















import Component, { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import { Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import ErrorMixin from "@/mixins/errorMixins";
import VueJsonToCsv from "vue-json-to-csv";
import moment from "moment/moment";
import GraphData, {
  DataSet,
  ChartOptions,
  MyOptions,
} from "@/charts/graphData";
import Doughnut from "@/charts/Doughnut.vue";
import ChartsCommon from "../homeGraph/chartsMixin";
import MyMixin from "@/mixins/datemixin";
import _ from "lodash";

@Component({
  components: { VueJsonToCsv, Doughnut },
})
export default class TotalHack extends mixins(
  MobileMixin,
  MyMixin,
  ErrorMixin,
  ChartsCommon
) {
  public search: string = "";

  public totalData = [
  {
    date: "2023-11-13T10:35:00+00:00",
    sujet: "Licences",
    de: "nikola.vlahovic@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-22T13:25:07+00:00",
    sujet: "Missing Transactions CSI",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-22T11:40:32+00:00",
    sujet: "Missing Transactions CSI",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-21T16:18:37+00:00",
    sujet: "Missing Transactions CSI",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-21T16:17:26+00:00",
    sujet: "Missing Transactions CSI",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-20T15:25:15+00:00",
    sujet: "Licences",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-20T09:00:27+00:00",
    sujet: "Licences",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-20T08:41:32+00:00",
    sujet: "Double ND number for two objects",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-20T08:00:35+00:00",
    sujet: "False License",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-20T07:46:51+00:00",
    sujet: "Double ND number for two objects",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-14T09:26:17+00:00",
    sujet: "Tenant Changes Total Energies",
    de: "rollout@acrelec.de",
    importance: "normal"
  },
  {
    date: "2023-11-13T14:37:30+00:00",
    sujet: "ND030528 Halle",
    de: "manfred.hartlmueller@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-13T10:35:00+00:00",
    sujet: "Licences",
    de: "nikola.vlahovic@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-10T13:13:46+00:00",
    sujet: "AW: Gifhorn Braunschweiger Str.",
    de: "csongor.foldes@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-10T09:49:35+00:00",
    sujet: "AW: Gifhorn Braunschweiger Str.",
    de: "csongor.foldes@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-10T09:24:54+00:00",
    sujet: "Licence is not there",
    de: "csongor.foldes@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-09T09:47:46+00:00",
    sujet: "TW6 Price Grid Issues",
    de: "jerome.bonnard@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-09T08:52:15+00:00",
    sujet: "TW6 Price Grid Issues",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-08T08:36:47+00:00",
    sujet: "AW: Tenant Changes Total Energies",
    de: "rollout@acrelec.de",
    importance: "normal"
  },
  {
    date: "2023-11-08T07:10:34+00:00",
    sujet: "AW: New Partner - ND000737 / ROMMERSKIRCHEN",
    de: "rollout@acrelec.de",
    importance: "normal"
  },
  {
    date: "2023-11-07T13:52:26+00:00",
    sujet: "Gifhorn Braunschweiger Str.",
    de: "csongor.foldes@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-06T08:45:24+00:00",
    sujet: "Price Group TW6 Issues",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-11-02T14:24:08+00:00",
    sujet: "Tenant Changes Total Energies",
    de: "rollout@acrelec.de",
    importance: "normal"
  },
  {
    date: "2023-11-02T11:31:51+00:00",
    sujet: "licences for the week45",
    de: "csongor.foldes@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-31T12:23:04+00:00",
    sujet: "AW: ND037481 HAAN",
    de: "ted@acrelec.de",
    importance: "normal"
  },
  {
    date: "2023-10-31T10:08:53+00:00",
    sujet: "ND037481 HAAN",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-30T16:09:40+00:00",
    sujet: "ND037481 HAAN",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-30T16:01:51+00:00",
    sujet: "ND037481 HAAN",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-30T15:28:48+00:00",
    sujet: "ND037481 HAAN",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-30T14:42:07+00:00",
    sujet: "ND037481 HAAN",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-30T08:04:40+00:00",
    sujet: "ND039149",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-27T11:49:38+00:00",
    sujet: "AW: Missing data in CSI",
    de: "manfred.hartlmueller@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-27T11:06:59+00:00",
    sujet: "ND039149",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-27T08:37:56+00:00",
    sujet: "AW: Missing data in CSI",
    de: "manfred.hartlmueller@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-27T08:34:05+00:00",
    sujet: "Missing data in CSI",
    de: "manfred.hartlmueller@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-27T06:38:46+00:00",
    sujet: "ND039149",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  },
  {
    date: "2023-10-26T14:06:04+00:00",
    sujet: "ND039149",
    de: "daniel.tomuta@acrelec.com",
    importance: "normal"
  }
];

  public info = {
    totalEmail: 0,
    numberOfSubject: 0,
    numberOfSubjectResponded: 0,
  };
  public emailByAdress: { [key: string]: number } = {};
  public emailBySubject: { [key: string]: number } = {};
  public responseBySubject: { [key: string]: number } = {};

  public emailsSubject: { [key: string]: string[] } = {};

  public emailResponseSup2: { [key: string]: number } = {};

  public firstMail: { [key: string]: string } = {};
  public firstResponse: { [key: string]: string } = {};

  public labels = new Array();
  public data = new Array();
  public dataGetted = false;
  public options: ChartOptions = new ChartOptions();

  public responseEmail = [
  {
    date: "2023-11-22T15:25:14+00:00",
    sujet: "Missing Transactions CSI",
    a: "acrelec-support@cashsystemes.eu;daniel.tomuta@acrelec.com",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-11-22T15:06:38+00:00",
    sujet: "Missing Transactions CSI",
    a: "daniel.tomuta@acrelec.com;acrelec-support@cashsystemes.eu",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-11-20T15:12:29+00:00",
    sujet: "Licences",
    a: "daniel.tomuta@acrelec.com;acrelec-support@cashsystemes.eu;nikola.vlahovic@acrelec.com;jerome.bonnard@acrelec.com;geoffrey.vanzo@acrelec.com",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-11-20T08:57:40+00:00",
    sujet: "Licences",
    a: "nikola.vlahovic@acrelec.com;acrelec-support@cashsystemes.eu;daniel.tomuta@acrelec.com",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-11-20T08:54:03+00:00",
    sujet: "Double ND number for two objects",
    a: "daniel.tomuta@acrelec.com;acrelec-support@cashsystemes.eu",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-11-20T08:37:26+00:00",
    sujet: "Double ND number for two objects",
    a: "daniel.tomuta@acrelec.com;acrelec-support@cashsystemes.eu",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-11-10T12:55:21+00:00",
    sujet: "Gifhorn Braunschweiger Str.",
    a: "csongor.foldes@acrelec.com",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-11-10T09:45:19+00:00",
    sujet: "Gifhorn Braunschweiger Str.",
    a: "csongor.foldes@acrelec.com",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-11-02T13:41:18+00:00",
    sujet: "Licences, efsta IDs for next week",
    a: "csongor.foldes@acrelec.com",
    importance: "normal",
    de: "l.prantoni@cashsystemes.eu",
  },
  {
    date: "2023-10-31T15:20:15+00:00",
    sujet: "ND037481 HAAN",
    a: "geoffrey.vanzo@acrelec.com;l.prantoni@cashsystemes.eu;acrelec-support@cashsystemes.eu",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-10-30T16:18:02+00:00",
    sujet: "ND037481 HAAN",
    a: "daniel.tomuta@acrelec.com;acrelec-support@cashsystemes.eu;fabian.ermer@acrelec.com;ted@acrelec.de",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-10-30T15:52:55+00:00",
    sujet: "ND037481 HAAN",
    a: "daniel.tomuta@acrelec.com;acrelec-support@cashsystemes.eu;fabian.ermer@acrelec.com",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-10-30T14:38:22+00:00",
    sujet: "ND037481 HAAN",
    a: "fabian.ermer@acrelec.com;acrelec-support@cashsystemes.eu",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",
  },
  {
    date: "2023-10-30T14:30:06+00:00",
    sujet: "ND031385",
    a: "fabian.ermer@acrelec.com;acrelec-support@cashsystemes.eu",
    importance: "normal",
    de: "acrelec-support@cashsystemes.eu",  }

  ];

  public mounted() {
    this.info.totalEmail = this.totalData.length - 1;

    this.totalData = _.orderBy(this.totalData, "date");
    this.responseEmail = _.orderBy(this.responseEmail, "date");

    this.totalData.map((mail: any) => {
      if (this.emailByAdress[mail.de] !== undefined) {
        this.emailByAdress[mail.de] += 1;
      } else {
        this.emailByAdress[mail.de] = 1;
      }
    });

    this.totalData.map((mail: any) => {
      if (this.emailBySubject[mail.sujet] !== undefined) {
        this.emailBySubject[mail.sujet] += 1;
      } else {
        this.emailBySubject[mail.sujet] = 1;
        this.info.numberOfSubject += 1;
        this.firstMail[mail.sujet] = mail.date;
      }
    });

    this.responseEmail.map((mail: any) => {
      if (this.responseBySubject[mail.sujet] !== undefined) {
        this.responseBySubject[mail.sujet] += 1;
      } else {
        this.responseBySubject[mail.sujet] = 1;
        this.info.numberOfSubjectResponded += 1;
        this.firstResponse[mail.sujet] = mail.date;
      }
    });

    this.totalData.map((mail: any) => {
      if (this.emailsSubject[mail.sujet] !== undefined) {
        this.emailsSubject[mail.sujet].push(mail.date);
      } else {
        this.emailsSubject[mail.sujet] = [mail.date];
      }
    });

    this.responseEmail.map((mail: any) => {
      if (this.emailsSubject[mail.sujet] !== undefined) {
        // console.log(mail.sujet, this.emailsSubject[mail.sujet]);
        this.emailsSubject[mail.sujet].push(mail.date);
      } else {
        this.emailsSubject[mail.sujet] = [mail.date];
      }
    });

    let resolutionImm = 0;
    const subjects = Object.keys(this.emailBySubject);
    subjects.forEach((label: string) => {
      if (this.emailBySubject[label] === 1) {
        resolutionImm++;
      }
    });

    const subjectsBis = Object.keys(this.firstMail);
    let time = 0;
    let numberOfResponse = 0;
    // console.log(this.firstMail, this.firstResponse);
    subjectsBis.forEach((mail: string) => {
      if (this.firstResponse[mail] !== undefined) {
        //  console.log(this.firstMail[mail], this.firstResponse[mail]);
        // console.log(this.firstMail[mail]);
        time += this.calculateDelta(
          this.firstMail[mail],
          this.firstResponse[mail]
        );
        //  console.log(time);
        numberOfResponse++;
        if (time > 120) {
          this.emailResponseSup2[mail] = time / 60;
        }
      }
    });

    // console.log("calcul temps de réponse moyen : ", time + "minutes" , numberOfResponse);

    console.log("volume total d'emails ", this.info.totalEmail);
    console.log("nombre total de sujets", this.info.numberOfSubject);
    console.log(
      "Taux de résolution au premier contact : ",
      (resolutionImm / this.info.numberOfSubject) * 100
    );

    console.log(
      "temps de réponse moyen",
      time / numberOfResponse + " minutes",
      time / 60 / numberOfResponse + " heures"
    );
    console.log(
      "taux de réponse",
      (numberOfResponse / this.info.numberOfSubject) * 100
    );
    console.log(
      "mail dont la réponse est supérieur à 2H",
      this.emailResponseSup2
    );

    console.log(this.emailsSubject);

    console.log("total Email", this.info);
    /* console.log(this.emailByAdress);*/
    // console.log(this.emailBySubject);
    // console.log(this.responseBySubject);

    /*this.orderData(this.emailBySubject);*/
    // this.options.makeMeAPercentDoughnut();
  }

  public calculateDelta(query: string, response: string) {
    const debut = moment(query, "YYYY-MM-DDThh:mm:ss");
    const end = moment(response, "YYYY-MM-DDThh:mm");
    const diff = end.diff(debut, "m");
    console.log(debut.toDate(), end.toDate(), "différence : " + diff);
    return diff;
  }

  public getFilteredSocietes(): Site[] {
    // console.log(this.societes);
    const socs = this.sites.filter(
      (societe: Site) =>
        societe.libelle.toUpperCase().includes(this.search.toUpperCase()) ||
        societe.restaurantId === parseInt(this.search)
    );

    socs.sort((u1: Site, u2: Site) => {
      if (u1.libelle > u2.libelle) {
        return 1;
      }
      if (u1.libelle < u2.libelle) {
        return -1;
      }
      return 0;
    });

    return socs;
  }

  private orderData(lignes: any) {
    // 1: vente, 0 : presta
    let labels = [];
    this.labels = [];

    labels = Object.keys(lignes);
    labels.forEach((label: string) => {
      if (label !== "") {
        this.labels.push(label);
        this.data.push(lignes[label]);
      }
    });
    console.log(this.labels);
    console.log(this.data);
    this.dataGetted = true;
  }

  // computed
  get sites(): any {
    return this.$store.getters["login/sites"];
  }
}
